const translations = {
  en: {
    nav: {
      about: "The Project",
      gallery: "Gallery",
      distribution: "Distribution",
      location: "Location",
      contact: "Contact",
      cta: "Request Info"
    },
    hero: {
      overline: "Hacienda Las Chapas, Marbella",
      title: "Your Dream Villa Awaits",
      subtitle: "Exclusive plot with approved architectural project and building license. Ready to build your luxury Mediterranean retreat.",
      cta: "Request Information",
      ctaSecondary: "View Project",
      badge: "License Approved"
    },
    about: {
      overline: "The Opportunity",
      title: "What Is For Sale",
      description: "An exclusive 1,925 m\u00B2 plot in the prestigious Hacienda Las Chapas urbanization, Marbella, sold together with a complete architectural project and an already approved building license. Construction can begin immediately.",
      includes: [
        "Plot in Hacienda Las Chapas (Parcela 259)",
        "Complete architectural project by Ismael M\u00E9rida",
        "Approved building license",
        "Detailed execution plans",
        "Modern villa design with infinity pool"
      ],
      includesTitle: "The sale includes"
    },
    stats: [
      { value: "5+", label: "Bedrooms" },
      { value: "7+", label: "Bathrooms" },
      { value: "1,925", label: "m\u00B2 Plot" },
      { value: "794", label: "m\u00B2 Built" },
      { value: "3", label: "Levels" },
      { value: "\u221E", label: "Infinity Pool" },
      { value: "3", label: "Car Parking" },
      { value: "Approved", label: "License" }
    ],
    gallery: {
      overline: "The Vision",
      title: "Architectural Design",
      subtitle: "A contemporary masterpiece designed to harmonize with the Mediterranean landscape",
      comingSoonTitle: "Drone Footage",
      comingSoonText: "Aerial video of the plot coming soon",
      droneTitle: "Drone Footage",
      droneSubtitle: "Aerial view of the plot at Hacienda Las Chapas",
      downloadPdf: "Download Full Project (PDF)"
    },
    floors: {
      overline: "Space Planning",
      title: "Floor Distribution",
      subtitle: "Total built area: 793.94 m\u00B2 across three levels",
      levels: [
        {
          name: "Basement",
          area: "232.23 m\u00B2",
          description: "Entertainment & wellness level",
          rooms: [
            { name: "Multi-purpose Living Room", area: "47.41 m\u00B2" },
            { name: "Bedroom 5", area: "20.26 m\u00B2" },
            { name: "Bedroom 4", area: "12.64 m\u00B2" },
            { name: "Office", area: "11.22 m\u00B2" },
            { name: "Atelier", area: "13.84 m\u00B2" },
            { name: "Walk-in Closet", area: "11.34 m\u00B2" },
            { name: "Laundry", area: "8.52 m\u00B2" },
            { name: "Wine Cellar", area: "Included" },
            { name: "Chill-Out Zone", area: "20.25 m\u00B2" },
            { name: "Covered Terrace", area: "70.08 m\u00B2" },
            { name: "Utilities", area: "20.45 m\u00B2" },
            { name: "Storage", area: "13.70 m\u00B2" }
          ]
        },
        {
          name: "Ground Floor",
          area: "154.97 m\u00B2",
          description: "Main living & entertainment",
          rooms: [
            { name: "Kitchen - Dining", area: "36.56 m\u00B2" },
            { name: "Living Room", area: "41.76 m\u00B2" },
            { name: "Master Bedroom 1", area: "21.50 m\u00B2" },
            { name: "Main Bathroom", area: "4.56 m\u00B2" },
            { name: "Guest WC", area: "2.91 m\u00B2" },
            { name: "Dirty Kitchen", area: "11.44 m\u00B2" },
            { name: "Zen Garden", area: "26.44 m\u00B2" },
            { name: "Covered Terrace", area: "42.69 m\u00B2" },
            { name: "Open Terrace", area: "59.18 m\u00B2" },
            { name: "Decorative Lake", area: "19.60 m\u00B2" }
          ]
        },
        {
          name: "First Floor",
          area: "166.11 m\u00B2",
          description: "Private bedroom suites",
          rooms: [
            { name: "Master Suite", area: "32.89 m\u00B2" },
            { name: "Walk-in Closets", area: "20.02 m\u00B2" },
            { name: "Master Bath 1", area: "6.89 m\u00B2" },
            { name: "Master Bath 2", area: "6.89 m\u00B2" },
            { name: "Bedroom 3", area: "24.10 m\u00B2" },
            { name: "Bedroom 2", area: "21.16 m\u00B2" },
            { name: "Bathroom 3", area: "4.32 m\u00B2" },
            { name: "Bathroom 2", area: "4.41 m\u00B2" },
            { name: "Gallery", area: "6.60 m\u00B2" },
            { name: "Sitting Room", area: "5.90 m\u00B2" },
            { name: "Terraces", area: "42.57 m\u00B2" }
          ]
        }
      ]
    },
    location: {
      overline: "Prime Location",
      title: "Hacienda Las Chapas",
      address: "Urb. Hacienda Las Chapas, Parcela 259, Marbella, M\u00E1laga",
      description: "One of Marbella's most prestigious residential areas, just minutes from golden beaches, world-class golf courses, and the vibrant Puerto Ban\u00FAs."
    },
    marbella: {
      overline: "The Neighbourhood",
      title: "Hacienda Las Chapas",
      subtitle: "A Private Retreat Among Pine Forests & the Sea",
      description: "Perched on a hillside between Cabopino and Elviria, Hacienda Las Chapas is one of East Marbella's most coveted residential enclaves. Palm-lined avenues wind through ancient pine forests, where roughly 500 luxury villas enjoy absolute privacy, 24-hour security, and breathtaking Mediterranean panoramas.",
      features: [
        "Gated community with 24h security",
        "Pine forest setting with sea views",
        "Top golf: Cabopino, Santa Clara, Marbella Golf",
        "Las Chapas & Cabopino beaches minutes away",
        "Bilingual schools within the urbanisation",
        "15 min to Marbella centre & Puerto Ban\u00FAs"
      ]
    },
    contact: {
      overline: "Get In Touch",
      title: "Interested in This Opportunity?",
      subtitle: "Leave us your details and we will contact you with all the information about this exclusive property.",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        message: "Message (optional)",
        submit: "Send Inquiry",
        success: "Thank you! We will contact you shortly.",
        error: "There was an error. Please try again."
      }
    },
    footer: {
      rights: "All rights reserved.",
      project: "Villa Project \u2014 Hacienda Las Chapas, Marbella",
      disclaimer: "Images are architectural renders. Final result may vary."
    }
  },
  es: {
    nav: {
      about: "El Proyecto",
      gallery: "Galer\u00EDa",
      distribution: "Distribuci\u00F3n",
      location: "Ubicaci\u00F3n",
      contact: "Contacto",
      cta: "Solicitar Info"
    },
    hero: {
      overline: "Hacienda Las Chapas, Marbella",
      title: "Tu Villa So\u00F1ada Te Espera",
      subtitle: "Parcela exclusiva con proyecto arquitect\u00F3nico aprobado y licencia de obra. Lista para construir tu refugio de lujo en el Mediterr\u00E1neo.",
      cta: "Solicitar Informaci\u00F3n",
      ctaSecondary: "Ver Proyecto",
      badge: "Licencia Aprobada"
    },
    about: {
      overline: "La Oportunidad",
      title: "\u00BFQu\u00E9 Se Vende?",
      description: "Una parcela exclusiva de 1.925 m\u00B2 en la prestigiosa urbanizaci\u00F3n Hacienda Las Chapas, Marbella, que se vende junto con un proyecto arquitect\u00F3nico completo y una licencia de obra ya aprobada. La construcci\u00F3n puede comenzar de inmediato.",
      includes: [
        "Parcela en Hacienda Las Chapas (Parcela 259)",
        "Proyecto arquitect\u00F3nico completo de Ismael M\u00E9rida",
        "Licencia de obra aprobada",
        "Planos de ejecuci\u00F3n detallados",
        "Dise\u00F1o de villa moderna con piscina infinita"
      ],
      includesTitle: "La venta incluye"
    },
    stats: [
      { value: "5+", label: "Dormitorios" },
      { value: "7+", label: "Ba\u00F1os" },
      { value: "1.925", label: "m\u00B2 Parcela" },
      { value: "794", label: "m\u00B2 Construidos" },
      { value: "3", label: "Plantas" },
      { value: "\u221E", label: "Piscina Infinita" },
      { value: "3", label: "Plazas Garaje" },
      { value: "Aprobada", label: "Licencia" }
    ],
    gallery: {
      overline: "La Visi\u00F3n",
      title: "Dise\u00F1o Arquitect\u00F3nico",
      subtitle: "Una obra maestra contempor\u00E1nea dise\u00F1ada para armonizar con el paisaje mediterr\u00E1neo",
      comingSoonTitle: "Im\u00E1genes con Dron",
      comingSoonText: "V\u00EDdeo a\u00E9reo de la parcela pr\u00F3ximamente",
      droneTitle: "V\u00EDdeo con Dron",
      droneSubtitle: "Vista a\u00E9rea de la parcela en Hacienda Las Chapas",
      downloadPdf: "Descargar Proyecto Completo (PDF)"
    },
    floors: {
      overline: "Distribuci\u00F3n",
      title: "Planos por Planta",
      subtitle: "Superficie total construida: 793,94 m\u00B2 en tres niveles",
      levels: [
        {
          name: "S\u00F3tano",
          area: "232,23 m\u00B2",
          description: "Entretenimiento y bienestar",
          rooms: [
            { name: "Sal\u00F3n Multiusos", area: "47,41 m\u00B2" },
            { name: "Dormitorio 5", area: "20,26 m\u00B2" },
            { name: "Dormitorio 4", area: "12,64 m\u00B2" },
            { name: "Oficina", area: "11,22 m\u00B2" },
            { name: "Atelier", area: "13,84 m\u00B2" },
            { name: "Vestidor", area: "11,34 m\u00B2" },
            { name: "Lavander\u00EDa", area: "8,52 m\u00B2" },
            { name: "Bodega", area: "Incluida" },
            { name: "Zona Chill-Out", area: "20,25 m\u00B2" },
            { name: "Terraza Cubierta", area: "70,08 m\u00B2" },
            { name: "Instalaciones", area: "20,45 m\u00B2" },
            { name: "Trastero", area: "13,70 m\u00B2" }
          ]
        },
        {
          name: "Planta Baja",
          area: "154,97 m\u00B2",
          description: "Vida social y entretenimiento",
          rooms: [
            { name: "Cocina - Comedor", area: "36,56 m\u00B2" },
            { name: "Sal\u00F3n", area: "41,76 m\u00B2" },
            { name: "Dormitorio 1", area: "21,50 m\u00B2" },
            { name: "Ba\u00F1o Principal", area: "4,56 m\u00B2" },
            { name: "Aseo", area: "2,91 m\u00B2" },
            { name: "Dirty Kitchen", area: "11,44 m\u00B2" },
            { name: "Jard\u00EDn Zen", area: "26,44 m\u00B2" },
            { name: "Terraza Cubierta", area: "42,69 m\u00B2" },
            { name: "Terraza Descubierta", area: "59,18 m\u00B2" },
            { name: "Lago Decorativo", area: "19,60 m\u00B2" }
          ]
        },
        {
          name: "Planta Primera",
          area: "166,11 m\u00B2",
          description: "Suites privadas",
          rooms: [
            { name: "Suite Principal", area: "32,89 m\u00B2" },
            { name: "Vestidores", area: "20,02 m\u00B2" },
            { name: "Ba\u00F1o Principal 1", area: "6,89 m\u00B2" },
            { name: "Ba\u00F1o Principal 2", area: "6,89 m\u00B2" },
            { name: "Dormitorio 3", area: "24,10 m\u00B2" },
            { name: "Dormitorio 2", area: "21,16 m\u00B2" },
            { name: "Ba\u00F1o 3", area: "4,32 m\u00B2" },
            { name: "Ba\u00F1o 2", area: "4,41 m\u00B2" },
            { name: "Galer\u00EDa", area: "6,60 m\u00B2" },
            { name: "Salita", area: "5,90 m\u00B2" },
            { name: "Terrazas", area: "42,57 m\u00B2" }
          ]
        }
      ]
    },
    location: {
      overline: "Ubicaci\u00F3n Privilegiada",
      title: "Hacienda Las Chapas",
      address: "Urb. Hacienda Las Chapas, Parcela 259, Marbella, M\u00E1laga",
      description: "Una de las zonas residenciales m\u00E1s prestigiosas de Marbella, a pocos minutos de playas doradas, campos de golf de clase mundial y el vibrante Puerto Ban\u00FAs."
    },
    marbella: {
      overline: "El Entorno",
      title: "Hacienda Las Chapas",
      subtitle: "Un Refugio Privado Entre Pinares y el Mar",
      description: "Situada en una colina entre Cabopino y Elviria, Hacienda Las Chapas es uno de los enclaves residenciales m\u00E1s exclusivos del este de Marbella. Avenidas flanqueadas de palmeras serpentean entre bosques de pinos centenarios, donde unas 500 villas de lujo disfrutan de privacidad absoluta, seguridad 24 horas y vistas panor\u00E1micas al Mediterr\u00E1neo.",
      features: [
        "Urbanizaci\u00F3n cerrada con seguridad 24h",
        "Entorno de pinares con vistas al mar",
        "Golf top: Cabopino, Santa Clara, Marbella Golf",
        "Playas de Las Chapas y Cabopino a minutos",
        "Colegios biling\u00FCes dentro de la urbanizaci\u00F3n",
        "15 min al centro de Marbella y Puerto Ban\u00FAs"
      ]
    },
    contact: {
      overline: "Contacto",
      title: "\u00BFInteresado en Esta Oportunidad?",
      subtitle: "D\u00E9janos tus datos y te contactaremos con toda la informaci\u00F3n sobre esta propiedad exclusiva.",
      form: {
        name: "Nombre Completo",
        email: "Correo Electr\u00F3nico",
        phone: "Tel\u00E9fono",
        message: "Mensaje (opcional)",
        submit: "Enviar Consulta",
        success: "\u00A1Gracias! Nos pondremos en contacto contigo pronto.",
        error: "Hubo un error. Por favor, int\u00E9ntalo de nuevo."
      }
    },
    footer: {
      rights: "Todos los derechos reservados.",
      project: "Proyecto Villa \u2014 Hacienda Las Chapas, Marbella",
      disclaimer: "Las im\u00E1genes son renders arquitect\u00F3nicos. El resultado final puede variar."
    }
  }
};

export default translations;
